<template>
  <div class="paymentError">
    <div class="pay_title">
      <van-icon name="cross" class="icon"/>
      <div>{{productName}}</div>
      <div>购买失败</div>
    </div>
    <div class="pay_content">请联系客服</div>
  </div>
</template>
<script>
export default {
  name: "paymentError",
  data() {
    return {
      productName: ""
    };
  },
  mounted() {
    document.title = "支付失败";
    this.productName = this.$route.query.productName;
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.paymentError {
  text-align: center;
  padding: 10rem 0 0;
  .pay_title {
    font-size: 1.5rem;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .icon {
      color: #ffffff;
      width: 2.5rem;
      height: 2.5rem;
      font-size: 2.5rem;
      background: #F56C6C;
      border-radius: 50%;
      padding: 0.3rem;
      margin-bottom: 0.5rem;
    }
  }
  .pay_content {
    margin-top: 1rem;
    font-size: 0.9rem;
  }
}
</style>

